import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';

@Component({
  selector: 'project-address-cell',
  templateUrl: './project-address-cell.component.html',
  styleUrls: ['./project-address-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatTooltipModule]
})
export class ProjectAddressCellComponent implements ListCustomCell {
  @ViewChild('template') template;
}
